import * as React from 'react';

import { Day } from './style';

interface RaceProgramDailyNumProps {
  isLastDay: boolean;
  dailyNum: number;
}

const RaceProgramDailyNum: React.FC<RaceProgramDailyNumProps> = ({
  isLastDay,
  dailyNum,
}) => {
  const getRaceDailyNum = () => {
    switch (dailyNum) {
      case 0: {
        return '';
      }
      case 1: {
        return '初日';
      }
      default: {
        return `${dailyNum}日目`;
      }
    }
  };

  return <Day>{isLastDay ? '最終日' : getRaceDailyNum()}</Day>;
};

export default RaceProgramDailyNum;
